<div class="px-4 md:px-8 lg:px-8 pt-7 md:pt-8 lg:pt-8 pb-8 h-fit rounded-lg w-md bg-white flex flex-col border-2 border-gray-200" >
  @if(!isLoading) {
    <afcu-loading [target]="''" />
  } @else {
    <afcu-title/>
    <form (submit)="onSubmit()" [formGroup]="form">
      <div class="flex flex-col gap-4 pt-4">
        @for (question of questions; track question) {
          <afcu-input [form]="form" [question]="question" (externalFunction)="select($event)"/>
        }
      </div>
      @if(errorPIN){
        <div class="mt-4">
          <afcu-banner [content]="errorBanner" state="error"/>
        </div>
      }
      <div class="flex mt-4 w-full justify-center gap-4">
        <button class="w-full md:w-fit lg:w-fit py-3.5 bg-afcu-navy-800 px-6 font-semibold text-white rounded cursor-pointer flex" type="submit">
          
          @if (form.valid){
            @if (!errorPIN && formSubmitted){
              <svg class="mr-3 -ml-1 size-5 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            }
          }
          <p class="pl-[40%] md:pl-0 lg:pl-0">Save</p>
        </button>
        <button [class]="(showCancel) ? 'block': 'hidden'" class="border border-gray-200 font-semibold px-5 py-3" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  }
</div>
